import { postRequestMall } from './request/request';
// 获取代金券列表(废弃)
// export const apiGetVoucherList = (params?: any) => postRequestMall('/benefit/receiveList', params)

// 领取优惠券(废弃)
// export const apiGetVoucher = (params?: any) => postRequestMall('/benefit/receive', params)

// 获取可用的代金券
export const apiGetUseVoucherList = function (params) {
  return postRequestMall('/benefit/useList', params);
};

// 获取banner 图
export const apiGetBanner = function (params) {
  return postRequestMall('/game/role/getBanner', params);
};

// 获取冻结代金券列表
export const apiGetLockVoucherList = function (params) {
  return postRequestMall('/benefit/lockBenefits', params);
};

// 刷新角色代金券数据
export const apiFlushConfirm = function (params) {
  return postRequestMall('/game/role/flushConfirm', params);
};

// 获取距离获得下一个代金券
export const apiGetNextBenefits = function (params) {
  return postRequestMall('/benefit/nextBenefits', params);
};

// 支付成功后获得的代金券
export const apiGetVoucherByPay = function (params) {
  return postRequestMall('/benefit/orderBenefits', params);
};